import { gql } from '@apollo/client';

export const GET_CONTACT_HEADERS = gql`
  query ContactsHeaders {
    GetContactsGridHeader
  }
`;
